export default __webpack_public_path__ + "static/media/home3dmodel.1b7e9503.png";